import { APIMethod as ApiMethods, fetchData } from "@client";

export async function updateXlsImportConfigQuery(
  configId,
  name,
  config,
) {
  return await fetchData(
    `/xls-configs/${configId}`,
    ApiMethods.PUT,
    {
      removeEmptyKeys: true,
      data: {
        name,
        config,
      }
    }
  );
}
